import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React from 'react';

interface IExternalLink {
  className?: string;
  to: string;
  type?: 'primary' | 'white' | 'secondary';
  target?: '_self' | '_blank' | '_parent' | '_top';
  title?: string;
  children: React.ReactNode;
}

export const ExternalLink = React.forwardRef<HTMLAnchorElement, any>(
  ({ to, children, className, type = 'primary', target, title }: IExternalLink, ref) => {
    const classes = useStyles();
    return (
      <a
        href={to}
        rel="noopener noreferrer"
        target={target}
        className={clsx(classes[type], className)}
        title={title}
        ref={ref}
      >
        {children}
      </a>
    );
  }
);

const useStyles = makeStyles(theme => ({
  white: {
    color: theme.palette.background.paper,
    textDecoration: 'none'
  },
  smallWhite: {
    color: theme.palette.background.paper,
    textDecoration: 'none',
    fontSize: '13px'
  },
  primary: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.primary.dark
    }
  },
  secondary: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.secondary.dark
    }
  }
}));
